import { showSuccess } from '@/components/AlertNotification';
import iaRequest from '@/iaRequest';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

interface CalendarAuthorizeResponse {
  url: string;
}

interface CalendarStatusResponse {
  provider: string;
  connected: boolean;
  account_email: string | null;
}

interface EventDetailsResponse {
  interview_scheduled_time: string;
  interview_timezone: string;
}

export const useGetCalendarAuthorize = (provider: string, redirectUrl: string) => {
  return useQuery({
    queryKey: ['GET_CALENDAR_AUTHORIZE', provider],
    queryFn: () => iaRequest.get(`calendar-oauth/${provider}/authorize?redirect_to=${redirectUrl}`),
    select: (data: AxiosResponse<CalendarAuthorizeResponse>) => data.data,
    enabled: false,
  });
};

export const useGetCalendarStatus = (provider: string, enabled?: boolean) => {
  return useQuery({
    queryKey: ['GET_CALENDAR_STATUS', provider],
    queryFn: () => iaRequest.get(`calendar-oauth/${provider}/status`),
    select: (data: AxiosResponse<CalendarStatusResponse>) => data.data,
    enabled: enabled ?? true,
  });
};

export const useDeleteCalendar = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['DELETE_CALENDAR'],
    mutationFn: async (provider: string) => {
      const response: AxiosResponse<{ message: string }> = await iaRequest.delete(`calendar-oauth/${provider}/revoke`);
      return response.data;
    },
    onSuccess: (_data, provider) => {
      queryClient.invalidateQueries({ queryKey: ['GET_CALENDAR_STATUS', provider] });
      showSuccess('Calendar disconnected successfully');
    },
  });
};

export interface IScheduleInterviewViaCalendarRequest {
  interview_id: number;
  resume_id: string;
  interviewee_name: string;
  interview_duration: number;
  candidate_email: string;
  start_time: string;
  end_time: string;
  timezone: string;
  provider: string;
  calendar_event_name: string;
}

export const useScheduleInterviewViaCalendar = () => {
  return useMutation({
    mutationKey: ['SCHEDULE_INTERVIEW_VIA_CALENDAR'],
    mutationFn: async (payload: IScheduleInterviewViaCalendarRequest) => {
      const response = await iaRequest.post('calendar-sync/schedule-interview', payload);
      return response.data;
    },
  });
};

export const useGetEventDetails = () => {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['GET_EVENT_DETAILS'],
    mutationFn: async (meet_link: string) => {
      const response: AxiosResponse<EventDetailsResponse> = await iaRequest.post(`calendar-sync/event-schedule`, {
        meet_link,
      });
      return response.data;
    },
    // onSuccess: (_data, provider) => {
    //   queryClient.invalidateQueries({ queryKey: ['GET_CALENDAR_STATUS', provider] });
    //   showSuccess('Calendar disconnected successfully');
    // },
  });
};
